export function filterEventsByNotifications(
  event: Record<string, unknown> = {},
  notification: Record<string, unknown> = {},
): boolean {
  const filter = notification.filters;

  if (!filter) return false;

  if (filter.age__gte !== null && event?.age < filter.age__gte) return false;
  if (filter.age__lt !== null && event?.age >= filter.age__lt) return false;

  if (filter.temperature__gte !== null
    && event?.user_data
    && Number(JSON.parse(event.user_data).t)
    && Number(JSON.parse(event.user_data).t) < filter.temperature__gte) return false;
  if (filter.temperature__lt !== null
    && event?.user_data
    && Number(JSON.parse(event.user_data).t)
    && Number(JSON.parse(event.user_data).t) >= filter.temperature__lt) return false;

  if (
    filter.top_similar_object_similarity__gte !== null
    && event?.top_match?.similarity < filter.top_similar_object_similarity__gte
  ) return false;
  if (
    filter.top_similar_object_similarity__lt !== null
    && event?.top_match?.similarity >= filter.top_similar_object_similarity__lt
  ) return false;

  if (filter.gender !== null && event?.gender !== filter.gender) return false;
  if (filter.emotions?.length && (!event?.emotion || !filter.emotions.includes(event?.emotion))) return false;
  if (filter.masks?.length && (!event?.mask || !filter.masks.includes(event?.mask))) return false;
  if (
    filter.tags?.length
    && (!event?.tags?.length || !event?.tags?.some((tag) => filter.tags.includes(tag)))) return false;

  if (filter.handlers?.length && !filter.handlers.includes(event?.handler_id)) return false;
  if (filter.sources?.length && !filter.sources.includes(event?.source)) return false;
  if (filter.lists?.length && !event?.listOptions?.every((list) => filter.lists.includes(list.value))) return false;

  return true;
}
